import itemImg00 from "../assets/img/about/aboutItem00.png"
import itemImg01 from "../assets/img/about/aboutItem01.png"
import itemImg02 from "../assets/img/about/aboutItem02.png"
import itemImg03 from "../assets/img/about/aboutItem03.jpg"
import itemImg04 from "../assets/img/about/aboutItem04.jpg"

const aboutItem = [
    {
        id: "aboutItem00",
        class: "timeline-inverted",
        img: itemImg00,
        heading: `"스카이스캐너, 야놀자 그 다음은?"`,
        subheading : "여행준비 3단계_교통편, 숙소, 짐",
        description: `항공편은 스카이스캐너,
                    숙소 예약은 야놀자,
                    그런데 짐은 어떻게 준비하시나요?`,
    },
    {
        id: "aboutItem01",
        class: "",
        img: itemImg01,
        heading: `"싸게 빌릴 순 없을까?"`,
        subheading : "비싼 캐리어 가격",
        description: `비싸면서 자주 쓰지도 않는 캐리어.
                    부피도 큰데... 빌릴 순 없을까?
                    캐리빌리의 고민은 여기서 출발합니다.`,
    },
    {
        id: "aboutItem02",
        class: "timeline-inverted",
        img: itemImg02,
        heading: `"저 멀쩡하고 비싼 걸 버려?"`,
        subheading : "버려지는 캐리어",
        description: `왜 버려질까요? 고장나서? 아닙니다.
                    부피도 크고 먼지만 쌓이다 보니 내놓는 거죠.`,
    },
    {
        id: "aboutItem03",
        class: "",
        img: itemImg03,
        heading: `"우리가 해보자!"`,
        subheading : "캐리빌리의 시작",
        description: `중고 캐리어를 저렴하게 매입하고 버려진 건 수거해서 열심히 닦았습니다.
                    고장난 건 부품까지 구해 직접 수리했죠.
                    그렇게 캐리빌리가 시작되었습니다.`,
    },
    {
        id: "aboutItem04",
        class: "timeline-inverted",
        img: itemImg04,
        heading: `"캐리어 업계의 에어비앤비를 꿈꾸며"`,
        subheading : "캐리빌리의 비전",
        description: `캐리빌리는 캐리어 부담없이 여행하는 세상을 꿈꿉니다.
                    당신은 온전히 여행에만 집중하시길 바라며.`,
    },
]

function AboutItems(){
    return (
        <div>
            <section className="page-section" id="about">
                <div className="container">
                    <div className="text-center">
                        <h2 className="section-heading text-uppercase">About</h2>
                        <h3 className="section-subheading text-muted">
                            캐리어에 대한 이런저런 생각
                        </h3>
                    </div>
                    <ul className="timeline">
                        {aboutItem.map((item) =>
                            <li className={item.class} key={item.id}>
                                <div className="timeline-image">
                                    <img
                                        className="rounded-circle img-fluid"
                                        src={item.img}
                                        alt={item.id}
                                    />
                                </div>
                                <div className="timeline-panel">
                                    <div className="timeline-heading">
                                        <h4 className="subheading">{item.heading}</h4>
                                        <h5>{item.subheading}</h5>
                                    </div>
                                    <div className="timeline-body">
                                        <p className="text-muted">
                                            {item.description}
                                        </p>
                                    </div>
                                </div>
                            </li>
                        )}
                        <li className="timeline-inverted" id="aboutItem05">
                            <div className="timeline-image">
                                <h4>
                                    Be Part
                                    <br />
                                    Of Our
                                    <br />
                                    Story!
                                </h4>
                            </div>
                        </li>
                    </ul>
                </div>
            </section>
        </div>
    )
}

export default AboutItems;